const COMMON_CONFIG = {
  SESSION_TIMEOUT: "30",
};
export default COMMON_CONFIG;
